/**
 * Date helpers. Always use the user's LOCAL calendar date for track/race
 * identifiers — `new Date().toISOString().slice(0, 10)` returns a UTC
 * date, which flips to tomorrow in the user's evening (e.g. 9pm ET is
 * already next-day UTC) and makes the scoring lookup query the wrong day.
 */

export const todayLocalIso = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
